(function () {

    "use strict";

    function textareaController() {

        var vm = this;

        vm.loadRows = function () {
            vm.rowsFinal = (vm.rows != null ? vm.rows : 1);
            vm.colsFinal = (vm.cols != null ? vm.cols : 1);
        };

    }

    textareaController.$inject = [];

    angular.module("sphforms.main")
        .component("sphFormsTextarea", {
            controller: textareaController,
            bindings: {
                nameLabel: "=",
                maxLength: "=",
                disable: "=",
                change: "&",
                rows: "=",
                cols: "=",
                model: "=",
                required: "="
            },
            templateUrl: "modules/main/components/ui/textarea/textarea.template.html"
        });

}());
